
import { sortBy } from "lodash";
import { Clinic } from "../types/records.types";

export type ClinicInfo = {
    id: number;
    name: string;
    phone: string;
    address: string
}

type StrictClinic = {
    color: string;
    moloni_serie: string;
    receptionist: NonNullable<Clinic["receptionist"]>;
  } & Omit<Clinic, "color" | "moloni_serie" | "receptionist">;
  
  
  export const makeClinicInfo = (clinics: Array<StrictClinic>): Array<ClinicInfo> => {
    if (!clinics?.length || clinics?.length < 1) return [{id:0, name:"", phone:"", address: ""}]
  
    const clinicsSorted = sortBy(clinics, (clinic) => clinic.id)
    .map((clinic) => ({
        id: clinic.id,
        name: clinic.receptionist.last_name,
        phone: clinic.receptionist.phone,
        address: clinic.receptionist.location
    }));
    
    return clinicsSorted
  }